<template>
  <div class="main-logs">
    <my-header
      :page_name="$t('navigation.headerTitles.logs')"
      show_usermenu
    ></my-header>

    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t("logs.log") }}</label>
        <el-select v-model="logSelected" @change="logChanged">
          <el-option
            v-for="logOption in logOptions"
            :key="logOption.value"
            :value="logOption.value"
            :label="logOption.label"
          ></el-option>
        </el-select>
      </div>
      <div class="settings-element">
        <label>{{ $t("logs.server") }}</label>
        <el-select v-model="serverSelected" @change="serverChanged" filterable>
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </div>
      <div
        class="settings-element"
        v-if="logSelected === 'server_log' || logSelected === 'upgrade_log'"
      >
        <label>{{ $t("logs.app") }}</label>
        <el-select v-model="appSelected" @change="appChanged" filterable>
          <el-option
            v-for="(app, index) in getAppsArray"
            :key="index"
            :value="app.path"
            :label="app.alias?app.name+' ('+app.alias+')':app.name"
          ></el-option>
        </el-select>
      </div>
      <div class="settings-element" v-if="logSelected === 'admin_task_log'">
        <label>{{ $t("logs.period") }}</label>
        <el-date-picker
          @change="periodChanged"
          v-model="periodSelected"
          type="month"
          :picker-options="datePickerOptions"
          :placeholder="$t('logs.periodNotSelect')"
          :clearable="false"
          value-format="-yyyy-MM"
        ></el-date-picker>
      </div>
      <div class="setting-element button" v-if="!notSelected">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('logs.refresh')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="refreshClick"
              class="el-icon-refresh-right"
              size="mini"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
      <div class="setting-element button">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('logs.lastSelected')"
          placement="bottom-start"
        >
          <el-button
            class="el-icon-d-arrow-left"
            size="mini"
            @click="restorePrevious"
          ></el-button>
        </el-tooltip>
      </div>
      <div
        class="setting-element checkboxes"
        v-if="logSelected === 'admin_task_log'"
      >
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('logs.reverseOrder')"
          placement="bottom-start"
        >
          <el-checkbox-button
            v-model="descOrder"
            size="mini"
            @change="periodChanged"
            ><span v-if="descOrder" class="el-icon-sort-up"></span
            ><span v-else class="el-icon-sort-down"></span
          ></el-checkbox-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('logs.savePeriod')"
          placement="bottom-start"
        >
          <el-checkbox-button
            v-model="preservePeriod"
            size="mini"
            @change="checkboxChanged"
            ><span class="el-icon-date"></span
          ></el-checkbox-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('logs.withCoef')"
          placement="bottom-start"
        >
          <el-checkbox-button
            v-model="withCoef"
            v-if="getUser && getUser.roletype === '0'"
            size="mini"
            @change="periodChanged"
            ><span class="el-icon-c-scale-to-original"></span
          ></el-checkbox-button>
        </el-tooltip>
      </div>
    </div>
    <div v-if="notSelected"></div>
    <div v-else>
      <tree></tree>
    </div>
  </div>
</template>

<script>
import Tree from "../../components/common/tree/Tree";
import Header from "../../components/reusable/header/Header";
import Vue from "vue";
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";
import { mapGetters } from "vuex";

export default {
  components: {
    myHeader: Header,
    Tree,
    dateInput: VueMonthlyPicker,
  },
  data() {
    return {
      notSelected: true,
      serverSelected: null,
      logSelected: null,
      appSelected: null,
      periodSelected: null,
      descOrder: false,
      preservePeriod: false,
      withCoef: false,
      max: moment(),
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      logOptions: [
        {
          value: "server_log",
          label: this.$t("logs.apps"),
        },
        {
          value: "admin_task_log",
          label: this.$t("logs.tasksAndInstruments"),
        },
        {
          value: "upgrade_log",
          label: this.$t("logs.updates"),
        },
      ],
    };
  },
  methods: {
    logChanged() {
      this.appSelected = null;
      this.periodSelected = null;
      this.notSelected = true;
      this.$store.commit("setLogType", this.logSelected);
      this.$store.commit("setCurrentTreeNode", null);
      this.serverChanged();
    },
    serverChanged() {
      this.$store.commit("setServerLogSelected", this.serverSelected);
      this.appSelected = null;
      this.notSelected = true;
      this.$store.commit("setCurrentTreeNode", null);

      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getApps", {
          serverSelected: this.serverSelected,
          specialUser: this.getUser.roletype === "1" ? true : false,
        })
        .then(() => {
          if (this.getAppsArray && this.getAppsArray.length === 0) {
            throw new Error("Access denied");
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
      if (this.preservePeriod && this.periodSelected) {
        this.periodChanged();
      } else this.periodSelected = null;
    },
    appChanged() {
      if (
        this.logSelected !== "server_log" &&
        this.logSelected !== "upgrade_log"
      )
        return;
      this.$store.commit("setLoading", true);
      this.$store.commit("setCurrentTreeNode", null);
      let params = this.paramsForAppLog();
      this.$store
        .dispatch("getCommonLog", {
          funcName: this.logSelected,
          params,
        })
        .then(() => {
          this.$localStorage.set(
            "wa-log",
            JSON.stringify(this.createObjectForSave())
          );
          this.notSelected = false;
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("changeTreeDataLog", null);
          this.$store.commit("setLoading", false);
        });
    },
    periodChanged() {
      if (this.logSelected !== "admin_task_log") return;
      if (!this.serverSelected) return;
      this.$store.commit("setLoading", true);
      this.$store.commit("setPeriodSelected", this.periodSelected);
      this.$store.commit("setCurrentTreeNode", null);
      let params = this.paramsForAdminTaskLog();
      this.$store
        .dispatch("getCommonLog", {
          funcName: this.logSelected,
          params,
        })
        .then(() => {
          this.$localStorage.set(
            "wa-log",
            JSON.stringify(this.createObjectForSave())
          );
          this.notSelected = false;
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("changeTreeDataLog", null);
          this.$store.commit("setLoading", false);
        });
    },
    refreshClick() {
      this.$store.commit("setLoading", true);
      let params;
      if (this.logSelected === "admin_task_log") {
        params = this.paramsForAdminTaskLog();
      } else if (
        this.logSelected === "server_log" ||
        this.logSelected === "upgrade_log"
      ) {
        params = this.paramsForAppLog();
      }
      this.$store
        .dispatch("getCommonLog", {
          funcName: this.logSelected,
          params,
        })
        .then(() => {
          this.notSelected = false;
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("changeTreeDataLog", null);
          this.$store.commit("setLoading", false);
        });
    },
    restorePrevious() {
      let savedData = JSON.parse(this.$localStorage.get("wa-log"));
      if (!!savedData && savedData.log && savedData.server) {
        this.$store.commit("setLoading", true);
        this.logSelected = savedData.log;
        this.$store.commit("setLogType", this.logSelected);
        if (!this.getServersArray.find((s) => s.id === savedData.server)) {
          this.$store.commit("setLoading", false);
          return;
        }
        this.serverSelected = savedData.server;
        this.$store.commit("setServerLogSelected", this.serverSelected);
        //если есть сохраненное приложение и лог подходящий
        if (savedData.log === "server_log" || savedData.log === "upgrade_log") {
          this.$store
            .dispatch("getApps", {
              serverSelected: this.serverSelected,
              specialUser: this.getUser.roletype === "1" ? true : false,
            })
            .then(() => {
              if (this.getAppsArray && this.getAppsArray.length === 0) {
                throw new Error("Access denied");
              }
              if (savedData.app) {
                const app = this.getAppsArray.find(
                  (a) => a.path === savedData.app
                );
                if (!app) {
                  this.$store.commit("setLoading", false);
                  return;
                }
                this.appSelected = savedData.app;
                return this.$store.dispatch("getCommonLog", {
                  funcName: this.logSelected,
                  params: this.paramsForAppLog(),
                });
              }
            })
            .then(() => {
              this.notSelected = false;
              this.$store.commit("setLoading", false);
            })
            .catch(() => {
              this.$localStorage.removeItem("wa-log");
              this.$store.commit("setLoading", false);
            });
        }
        //если сохрененный месяц и лог подходящий
        else if (savedData.period && this.logSelected === "admin_task_log") {
          this.periodSelected = savedData.period;
          this.$store.commit("setPeriodSelected", this.periodSelected);
          this.$store
            .dispatch("getCommonLog", {
              funcName: this.logSelected,
              params: this.paramsForAdminTaskLog(),
            })
            .then(() => {
              this.notSelected = false;
              this.$store.commit("setLoading", false);
            })
            .catch(() => {
              this.$localStorage.removeItem("wa-log");
              this.$store.commit("setLoading", false);
            });
        } else {
          this.$store.commit("setLoading", false);
        }
      } else this.$message(this.$t("logs.lastSelectNotFound"));
    },
    checkboxChanged() {
      this.$localStorage.set(
        "wa-log",
        JSON.stringify(this.createObjectForSave())
      );
    },
    createObjectForSave() {
      const objectForLS = {
        server: this.serverSelected,
        log: this.logSelected,
        app: this.appSelected,
        period: this.periodSelected,
        desc: this.descOrder,
        preservePeriod: this.preservePeriod,
        withCoef: this.withCoef,
      };
      return objectForLS;
    },
    paramsForAdminTaskLog() {
      let params = {
        idServer: this.serverSelected,
        month: this.periodSelected
      };
      if (this.descOrder) params.sort = "desc";
      if (this.withCoef) params.kf = 1;
      if (this.getUser.roletype === "1") {
        let path = [];
        this.getAppsArray.forEach((app) => path.push(app.path));
        params.path = path;
      }
      return params;
    },
    paramsForAppLog() {
      const params = {
        idServer: this.serverSelected,
        pathSection: this.appSelected,
      };
      return params;
    },
  },
  computed: {
    ...mapGetters(["getServersArray", "getAppsArray", "getUser"]),
  },
  created() {
    this.$store
      .dispatch("getServers", this.getUser.roletype === "1")
      .then(() => {
        let savedData = JSON.parse(this.$localStorage.get("wa-log"));
        if (savedData && savedData.desc) this.descOrder = savedData.desc;
        if (savedData && savedData.preservePeriod)
          this.preservePeriod = savedData.preservePeriod;
        if (savedData && savedData.withCoef) this.withCoef = savedData.withCoef;
      })
      .catch((error) => {
        console.error(error);
        if (error === "Access denied") {
          this.serverSelected = null;
          this.appSelected = null;
          this.logSelected = null;
          this.logOptions = [];
        }
      });
  },
};
</script>

<style scoped>
.settings-element .el-button {
  /* margin-bottom: 5px; */
  transform: scale(0.9);
}
.settings-element .el-date-editor {
  margin-top: 3px;
}
.setting-element.button {
  margin: 12px 6px;
}
.setting-element.checkboxes {
  margin-top: 8px;
}
.setting-element .el-checkbox-button {
  transform: scale(0.7);
  margin-top: 0px;
  margin-bottom: -10px;
  margin-right: -15px;
}
</style>